'use client';

import React, { useEffect, useState } from 'react';
import { Container, Row } from 'reactstrap';
import Image from 'next/image';
import { useEnvContext } from '@/context/envContext';

//import components
import { SearchBar } from '../SearchBar/SearchBar';
import UserNav from '../UserNav/UserNav';
import { pushGTMClickTags } from '@/libs/pushGTMTags/pushGTMTags';
function Header() {
  const {
    cdnEnv
  } = useEnvContext();

  // If cdnEnv is undefined use prods hardcoded url path, will happen on notFoumd page
  const desktopFallbackLogo = '/hub/images/TechTarget-Logo_color-black.svg';
  const desktopCdnLogo = cdnEnv ? `${cdnEnv}/rms/ux/responsive/img/techtarget_logo_black.svg` : 'https://media.techtarget.com/rms/ux/responsive/img/techtarget_logo_black.svg';
  const mobileFallbackLogo = '/hub/images/TechTarget-Logo_stacked_color-black.svg';
  const mobileCdnLogo = cdnEnv ? `${cdnEnv}/rms/ux/responsive/img/techtarget_logo_black_stacked.svg` : 'https://media.techtarget.com/rms/ux/responsive/img/techtarget_logo_black_stacked.svg';
  const [desktopLogoSrc, setDesktopLogoSrc] = useState(desktopCdnLogo);
  const [mobileLogoSrc, setMobileLogoSrc] = useState(mobileCdnLogo);
  useEffect(() => {
    setDesktopLogoSrc(desktopCdnLogo);
  }, [desktopCdnLogo]);
  useEffect(() => {
    setMobileLogoSrc(mobileCdnLogo);
  }, [mobileCdnLogo]);
  return <Container className={'site-header'} data-bdd={'site-header'} data-sentry-element="Container" data-sentry-component="Header" data-sentry-source-file="Header.tsx">
   <Row className={'header-top'} data-bdd={'header-top'} data-sentry-element="Row" data-sentry-source-file="Header.tsx">
    <a className={'comp-brand text-links-body-color'} href="https://www.techtarget.com/network/" onClick={() => {
        pushGTMClickTags({
          click_element: 'Anchor',
          click_section_ID: 'NONE',
          link_classes: 'comp-brand text-links-body-color',
          link_id: 'NONE',
          link_text: 'TechTarget network',
          link_url: 'https://www.techtarget.com/network/',
          click_category: 'NONE',
          click_destination: 'TechTarget Network',
          click_closest_href: 'NONE'
        });
      }}>
     TechTarget Network
    </a>
    <UserNav data-sentry-element="UserNav" data-sentry-source-file="Header.tsx" />
   </Row>

   <Row className={'header-bottom'} data-bdd={'header-bottom'} data-sentry-element="Row" data-sentry-source-file="Header.tsx">
    <div className={'tt-logo'} data-bdd={'site-logo'}>
     <Image className="d-none d-md-block" src={desktopLogoSrc} width={'202'} height={'44'} style={{
          width: 'auto',
          height: '44px'
        }} priority={true} alt={'Techtarget logo'} onError={() => {
          setDesktopLogoSrc(desktopFallbackLogo);
        }} data-sentry-element="Image" data-sentry-source-file="Header.tsx" />
     <Image className="d-block d-md-none" src={mobileLogoSrc} width={'84'} height={'44'} style={{
          width: 'auto',
          height: '44px'
        }} priority={true} alt={'Techtarget logo stacked'} onError={() => {
          setMobileLogoSrc(mobileFallbackLogo);
        }} data-sentry-element="Image" data-sentry-source-file="Header.tsx" />
     <p className={'logo-strap'} data-bdd={'logo-strapline'}>
      <span>Content</span>
      <span> Hub</span>
     </p>
    </div>

    <SearchBar data-sentry-element="SearchBar" data-sentry-source-file="Header.tsx" />
   </Row>
  </Container>;
}
export default Header;